import { apiClient, setAccessToken } from './client'
import type { LoginResponse, MeResponse } from '@/types/api'

export async function login(email: string, password: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', { email, password })
  setAccessToken(data.access_token)
  return data
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout')
  setAccessToken(null)
}

export async function getMe(): Promise<MeResponse> {
  const { data } = await apiClient.get<MeResponse>('/me')
  return data
}

export async function forgotPassword(email: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/forgot-password', { email })
  return data
}

export async function resetPassword(token: string, password: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/reset-password', { token, password })
  return data
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  })
  return data
}

export async function requestMagicLink(email: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/magic-link', { email })
  return data
}

export async function verifyMagicLink(token: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/magic-link/verify', { token })
  setAccessToken(data.access_token)
  return data
}

export async function setupPassword(password: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/setup-password', { password })
  return data
}
